/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { WorkflowAcknowledgementDraftStatus } from './workflowAcknowledgementDraftStatus';

/**
 * ``POST /auto-draft/regenerate`` and similar fire-and-forget
 * responses that hand back a workflow id for the UI to poll.
 */
export interface WorkflowAcknowledgement {
  /** @maxLength 255 */
  workflow_id: string;
  draft_status: WorkflowAcknowledgementDraftStatus;
}
